import React from 'react'
import { useTranslation } from 'react-i18next'

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

const DeleteProfileConfirmDialog = ({
  open,
  onConfirm,
  onCancel,
  profileName
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
    >
      <DialogTitle>
        {t('mailTemplate.users.modal.deleteProfileConfirm.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('mailTemplate.users.modal.deleteProfileConfirm.message', { profileName })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('mailTemplate.users.modal.deleteProfileConfirm.cancel')}
        </Button>
        <Button onClick={onConfirm} color="error" variant="contained" autoFocus>
          {t('mailTemplate.users.modal.deleteProfileConfirm.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeleteProfileConfirmDialog
